import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, Row, ModalHeader } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const API_BASE_URL = "https://api.hanoch.in/api/parts";
const AddAlarms = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [editedPart, setEditedPart] = useState(null);
  const [partData, setPartData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedPartId, setSelectedPartId] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const navigate = useNavigate();
  const itemsPerPage = 12;
  const [isLoading, setIsLoading] = useState(false);
  const authToken = localStorage.getItem("access");
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    description: "",
    id: ""
  });

  const toggleModal = () => {
    setModalVisible(!modalVisible);
    setEditedPart(null);
  }

  useEffect(() => {
    fetchPart();
  }, []);

  useEffect(() => {
    if (editedPart) {
      setFormData({
        name: editedPart.name,
        number: editedPart.number,
       
        description: editedPart.description,
        id: editedPart.id
      });
    } else {
      setFormData({
        name: "",
        number: "",
        description: "",
        id: ""
      });
    }
  }, [editedPart]);
  const handleInputChange = (e) => {
    const { id, value, files, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === "file" ? files[0] : value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataObject = new FormData();
    formDataObject.append("name", formData.name);
    formDataObject.append("number", formData.number);
    formDataObject.append("description", formData.description);
    const apiUrl = editedPart
      ? `${API_BASE_URL}/${editedPart.id}/`
      : `${API_BASE_URL}/`;
    try {
      const response = await fetch(apiUrl, {
        method: editedPart ? "PUT" : "POST",
        body: formDataObject,
      });
      const responseData = await response.json();
      if (response.ok) {
        toast.success(editedPart ? "Part updated successfully" : "Part added successfully");
        setModalVisible(false);
        setFormData({
          name: "",
          number: "",
          description: "",
          id: ""
        });
        fetchPart();
      } else {
        toast.error(`Error: ${responseData.error || "Something went wrong"}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const fetchPart = async () => {
    try {
           setIsLoading(true);
      const response = await fetch(API_BASE_URL, {
      });
      if (response.ok) {
        const data = await response.json();
        setPartData(data);
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    finally{
        setIsLoading(false);
    }
  };
  const handleDeletePart = async (id) => {
   // console.log("Delete function triggered for part ID:", id);
    try {
      const response = await fetch(
        `https://api.hanoch.in/api/parts/${id}/`,
        {
          method: "DELETE",
          // headers: {
          //   Authorization: `Bearer ${authToken}`,
          // },
        }
      );
      if (response.ok) {
        if (response.status !== 204) {
          const data = await response.json();
          console.log("Success response", data);
        }
        toast.success("Part Deleted Successfully");
        fetchPart();
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error deleting part:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting part:", error);
    }
  };
  const handlePartClick = (id) => {
    setSelectedPartId(id);
    navigate("/bom", { state: { id } })
  };
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const filteredPart = partData.filter((part) =>
    (part.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );
  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredPart.length / itemsPerPage);
  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // Get the items for the current page
  const currentItems = filteredPart.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Alarm" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    Add, Edit & Remove Parts
                  </h4>
                </CardHeader>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={toggleModal}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add New alarm
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
 {isLoading ? (
                      <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="sort" data-sort="customer_name">
                              Part Name
                            </th>
                            <th className="sort" data-sort="email">
                              Cavity No
                            </th>
                            <th className="sort" data-sort="phone">
                              Part Description
                            </th>

                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {currentItems === undefined ? (
                            <tr>
                              <td colSpan="9" className="text-center">
                                Loading...
                              </td>
                            </tr>
                          ) : currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No content found
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((part, index) => (

                              <tr key={index} onClick={() => handlePartClick(part.id)}  style={{
                      cursor: "pointer"}}>

                                <td className="part_name">
                                  {part.name}
                                </td>
                                <td className="part_number">
                                  {part.number}
                                </td>
                                <td className="email">
                                  {part.description}
                                </td>

                                <td>
                                  <div className="d-flex gap-2">
                                    <div className="edit">
                                      <button
                                        className="btn btn-warning"
                                        onClick={(e) => {
                                           e.stopPropagation();
                                          setModalVisible(true);
                                          setEditedPart(part);
                                        }}
                                      >
                                        Edit
                                      </button>
                                    </div>
                                    <div className="remove">
                                      <button
                                        className="btn btn-danger remove-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteRecordModal"
                                        onClick={(e) =>{
                                           e.stopPropagation();
                                            handleDeletePart(part.id);
                                        }
                                         
                                        }
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>
                    )}
                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${currentPage === 1 ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${currentPage === totalPages ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modalVisible}
        toggle={() => {
          setModalVisible(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            toggleModal();
          }}
        >
          {editedPart ? "Edit Part" : "Add Part"}
        </ModalHeader>
        {responseMessage && (
          <div
            className={`alert ${responseMessage.includes("Error")
                ? "alert-danger"
                : "alert-success"
              } `}
          >
            {responseMessage}
          </div>
        )}
        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3" id="modal-id" style={{ display: "none" }}>
              <label htmlFor="id-field" className="form-label">
                ID
              </label>
              <input
                type="text"
                id="id-field"
                value={formData.id}
                className="form-control"
                placeholder="ID"
                readOnly
              />
            </div>

            <div className="mb-3">
              <label htmlFor="part_name-field" className="form-label">
                Part Name
              </label>

              <input
                type="text"
                id="name"
                className="form-control"
                placeholder="Part Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="topic-field" className="form-label">
                Cavity No
              </label>
              <input
                type="text"
                id="number"
                className="form-control"
                placeholder="Part No"
                value={formData.number}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="part-description" className="form-label">
                Part Description
              </label>
              <input
                type="text"
                id="description"
                className="form-control"
                placeholder="Enter part description"
                value={formData.description}
                onChange={handleInputChange}
                required
              />
            </div>

          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handleSubmit}
              >
                {" "}
                {editedPart ? "Update Part" : "Add Part"}
              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default AddAlarms;
